<template>
	<div>
		<div class="flex">
			<div class="border-gray p-2">
				<div class="flex">
					<img :src="teacherDetails.photo_image" alt="" style="width: 60px;height: 60px;" />
					<div class="ms-2">
						<div class="ftr-1-2 cl-black ftw600">
							{{teacherDetails.name}}{{teacherDetails.surname}}
						</div>
						<div>
							(Tutor ID: {{teacherDetails.id}})
						</div>
						<div>
							{{timeZone}}
						</div>
					</div>
				</div>
				<div class="">
					{{$t('classManage.currentLevel')}}: {{teacherDetails.teacher_level.name}}
				</div>
				<div class="flex alcenter">
					<div class="progress" role="progressbar" style="width: 260px;"
						aria-label="Success example" aria-valuenow="25" aria-valuemin="0"
						aria-valuemax="100">
						<div class="progress-bar bg-theme" :style="'width:' + ((teacherDetails.teacher_level_value/levelInfo.value_min) * 100)+  '%'"></div>
					</div>
					<div class="ml10">
						({{teacherDetails.teacher_level_value}}/{{levelInfo.value_min}})
					</div>
				</div>
				<div class="ft14 mt-1">
					<!-- 距離下次升級還有187小時 -->
					{{$t('classManage.upgrade',{hour: ((levelInfo.value_min) - teacherDetails.teacher_level_value)})}}
				</div>
				<div class="ft14 classManage-color cl-theme mt-1 clickAct" @click="comVisible = true">
					<!-- 查看分成比例 -->
					{{$t('classManage.viewCommissionRatio')}}
				</div>
				
			</div>
		
			<div class="ms-3 flex column space">
				<div class="border-gray p-2 flex around" style="width: 300px;"> 
					<div class="text-center">
						<div class="ftr-2 ftw600 cl-black">
							{{teacherDetails.current_students}}
						</div>
						<div class="cl-info ft12">
							{{$t('teacherVue.teacherCenter1')}}
						</div>
					</div>
					<div class="text-center">
						<div class="ftr-2 ftw600 cl-black">
							{{teacherDetails.new_students}}
						</div>
						<div class="cl-info ft12">
							{{$t('teacherVue.teacherCenter2')}}
						</div>
					</div>
					<div class="text-center">
						<div class="ftr-2 ftw600 cl-black">
							{{teacherDetails.reservation_courses}}
						</div>
						<div class="cl-info ft12">
							{{$t('teacherVue.teacherCenter3')}}
						</div>
					</div>
					<div class="text-center">
						<div class="ftr-2 ftw600 cl-black">
							{{teacherDetails.courses_count - teacherDetails.reservation_courses}}
						</div>
						<div class="flex">
							<div class="cl-info ft12">
								{{$t('teacherVue.teacherCenter4')}}
							</div>
							<img src="../../../assets/image/teacher/myStudents2.png" alt="" style="width: 16px;height: 16px;margin-left: 10px;" />
						</div>
						
					</div>
				</div>
				<div class="border-gray p-3 mt-3 flex alcenter space">
					<div class="ftr-1-2">
						{{teacherDetails.is_cloaking==2?$t('teacherVue.teacherCenter5'):$t('teacherVue.teacherCenter6')}}
					</div>
					<button type="button" class="btn btn-theme" @click="updateIsCloaking(1)" v-if="teacherDetails.is_cloaking==2">{{ $t('teacherSet.setToCloaking') }}</button>
					<button type="button" class="btn btn-theme" @click="updateIsCloaking(2)" v-if="teacherDetails.is_cloaking==1">{{ $t('teacherSet.cancelCloaking') }}</button>
					<!-- <button class="btn btn-theme">{{$t('teacherSet.cloaking')}}</button> -->
				</div>
			</div>
			<div class="ms-3 border-gray p-2" style="height: 84px;width: 300px;">
				<div class="ftw600 cl-black ftr-1-2">
					{{$t('wallet.availableBalance')}}
				</div>
				<div class="ftr-1-5 ftw600 cl-black flex alcenter space" >
					{{getCurrency()}}
					{{convertCurrency(teacherDetails.money)}} 
					<img src="../../../assets/image/teacher/teacherCenter1.png" alt="" style="width: 25px;height: 25px;" />
				</div>
				<div class="ftr-1-25 ftw600 mt-4">
					{{ $t('userCenter.toDoList') }}
				</div>
				<div class="mt-3 border-gray br4 p-3" style="max-width: 400px;"
					v-for="(item,index) in disCoursePackageList">
					<div class="cl-red ftw600">
						{{ $t('userCenter.timeLimitedOffer') }}
					</div>
					<div class="mt-2 d-flex align-items-center">
						<img :src="item.photo_image" alt="" class="userCenter-head" />
						<div class="cl-17AAEA ml10 ftw600">
							{{item.name}} {{item.surname}}
						</div>
					</div>
					<div class="ftw600 mt-1">
						<!-- 正式课 -->
						{{$t('becomeTeacher.formalClass')}}
					</div>
					<div class="cl-info">
						{{item.course_name}}: {{$t('common.numberClass',{num:item.quantity})}} x
						{{getCurrency()}}{{convertCurrency(item.once_price)}}(50{{$t('forClassIndex.minute')}})
					</div>
					<div class="cl-info border-b">
						{{$t('common.endTime')}}:{{convertToTimeZone(item.finish_time).formattedTime}}
					</div>
					<div class="d-flex flex-column align-items-center mt-2">
						<button type="button" class="btn btn-theme bg-theme border-theme px-5"
							@click="toCashDesk(item)">{{ $t('userCenter.purchase') }}</button>
						<div class="ft14 cl-red flex alcenter">
							{{ $t('userCenter.remainingTime') }}
							<countdown :targetTime="convertToTimeZone(item.finish_time).formattedTime" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="mt-3 flex">
			<div>
				<div class="ftw600">
					{{$t('studentsCom.calendar')}}
				</div>
				<div style="width: 340px;" class="mt-2 p-2">
					<a-calendar  :fullscreen="false" @panelChange="" />
				</div>
				<div class="mt-3 ftw600">
					{{$t('teacherIndex.myStudents')}}
				</div>
				<div class="mt-2 border-gray flex p-2" v-for="(item,index) in studentsList">
					<img :src="item.user_info.avatar" alt="" style="width: 30px;height: 30px;" />
					<div class="ms-2">
						<div class="cl-theme">
							{{item.user_info.nickname}}
						</div>
						<div class="flex">
							<div>
								{{item.course_info.name}}
							</div>
							<div class="ms-3">
								{{$t('common.surplus')}}{{item.residue_quantity}}
							</div>
							<img src="../../../assets/image/teacher/myStudents1.png" class="ms-2" style="width: 23px;height: 23px;" :title="$t('teacherIndex.textMessage')" alt="" />
							<img src="../../../assets/image/teacher/myStudents2.png" class="ms-2" style="width: 20px;height: 20px;" :title="$t('myStudents.appointmentClass')" alt="" />
							<!-- <img src="../../../assets/image/teacher/myStudents3.png" style="width: 25px;height: 25px;"
							class="myStudents-icon" :title="$t('teacherIndex.sellingHall')" alt="" /> -->
							<!-- <img src="../../../assets/image/teacher/myStudents4.png" class="myStudents-icon"
							 :title="$t('common.progressReport')" alt="" /> -->
						</div>
					</div>
				</div>
			</div>
			
			<div  class="ms-3">
				<div class="ftw600">
					{{$t('common.aboutToBegin')}}
				</div>
				<div class="border-gray br4 py-2 mt-2 mr15 d-flex" style="width: 295px;"
					v-for="(item,index) in orderList">
					<div class=" text-center" style="border-right: 1px solid #D2D2D2;width: 75px;">
						<div class="ft14">
							{{convertToTimeZone(item.finish_time).date.month}}
							<!-- {{item.split_finish_time.month}}月 -->
						</div>
						<div class="ftr-2">
							<!-- {{item.split_finish_time.day}} -->
							{{convertToTimeZone(item.finish_time).date.day}}
						</div>
						<div class="cl-info ft14">
							<!-- 周{{item.split_finish_time.week}} -->
							{{changeNum( convertToTimeZone(item.finish_time).date.week)}}
						</div>
					</div>
					<div class="ml15">
						<div class="ft14">
							{{convertToTimeZone(item.start_time).date.hour}}:{{convertToTimeZone(item.start_time).date.minute}}
							-
							{{convertToTimeZone(item.finish_time).date.hour}}:{{convertToTimeZone(item.finish_time).date.minute}}
						</div>
						<div class="d-flex align-items-center mt-1">
							<img :src="item.photo_image" alt="" class="userCenter-head" />
							<span class="ml10 ftw600">{{item.name}}</span>
						</div>
						<div class="cl-theme ft14 clickAct mt-1" @click="toClass(item.id)">
							{{ $t('userCenter.viewClass') }}
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="comVisible">
			<view-commission :visible="comVisible" @cancel="comVisible = false"></view-commission>
		</div>
	</div>
</template>

<script>
	import viewCommission from './viewCommission.vue'
	export default{
		components:{
			viewCommission
		},
		data() {
			return{
				timeZone: localStorage.getItem('timeZone') || 'UTC',
				levelInfo:{},
				comVisible:false,
				orderList:[],
				studentsList:[],
				disCoursePackageList:[],
				teacherDetails:{}
			}
		},
		created() {
			this.getTeacherInfo()
			this.getOrderList()
			this.userCoursePackageList()
			this.getDisCoursePackage()
			
		},
		methods:{
			getTeacherInfo(){
				this.$http.api('teacher/teacher/info').then(res=>{
					this.teacherDetails = res.info
					this.getLevelList()
				})
			},
			toClass(id){
				this.$router.push('/statusConfirms?id=' + id)
			},
			toCashDesk(item) {
				this.$router.push('/cashDesk?item=' + JSON.stringify(item))
			},
			updateIsCloaking(num){
				this.$http.api('teacher/teacher/updateIsCloaking',{
					is_cloaking:num
				}).then(res=>{
					this.$message.success(this.$t('common.setSuccess'),1,()=>{
						// this.getTeacherInfo()
						this.teacherDetails.is_cloaking = num
					})
				})
			},
			getLevelList(){
				this.$http.api('teacher/teacher/levelList').then(res => {
					 res.list.forEach((item,index)=>{
						 if(item.name===this.teacherDetails.teacher_level.name){
							 if(index == res.list.length-1){
								 // 满级
								 item.value_min = item.value_max
								  this.levelInfo = item
							 }else{
								 this.levelInfo = res.list[index+1]
							 }
							 
						 }
					 })
				})
			},
			userCoursePackageList(){
				this.list = []
				this.$http.api('teacher/user/userCoursePackageList',{
					page:1,
					limit:100,
					status:1
				}).then(res=>{
					this.studentsList = res.list
				})
			},
			getOrderList() {
				this.$http.api('reservation/orderList', {
					page: 1,
					limit: 100,
					status:1,
					confirmation_status:1
				}).then(res => {
					this.orderList = res.list
				})
			},
			getDisCoursePackage() {
				this.$http.api('marketing/discountedCoursePackage', {}).then(res => {
					this.disCoursePackageList = res.list
				})
			},
		}
	}
</script>

<style>
	.userCenter-head {
		width: 40px;
		height: 40px;
		border-radius: 50%;
	}
</style>